export default __webpack_public_path__ + "static/media/react-native.90fb0021.png";